import React from 'react';
import { RotateCcw, Shuffle, CheckCircle } from 'lucide-react';

type ActionButtonsProps = {
  onReset: () => void;
  onRandomize: () => void;
  onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onReset,
  onRandomize,
  onSave
}) => (
  <div className="p-3 border-b border-zinc-700">
    <div className="flex gap-2">
      <button
        onClick={onReset}
        className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-zinc-700 hover:bg-zinc-600 text-zinc-300 hover:text-white rounded-lg text-sm"
        title="Reset to defaults"
      >
        <RotateCcw className="h-4 w-4" />
        Reset
      </button>
      <button
        onClick={onRandomize}
        className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-zinc-700 hover:bg-zinc-600 text-zinc-300 hover:text-white rounded-lg text-sm"
        title="Randomize all settings"
      >
        <Shuffle className="h-4 w-4" />
        Random
      </button>
      <button
        onClick={onSave}
        className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-zinc-700 hover:bg-zinc-600 text-zinc-300 hover:text-white rounded-lg text-sm"
        title="Save theme to your profile"
      >
        <CheckCircle className="h-4 w-4" />
        Save Theme
      </button>
    </div>
  </div>
);